"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDigitChar = exports.isSpecialChar = exports.isLetterChar = exports.KeyPress = exports.KeyCode = void 0;
var KeyCode;
(function (KeyCode) {
    KeyCode[KeyCode["ALT"] = 18] = "ALT";
    KeyCode[KeyCode["UPARROW"] = 38] = "UPARROW";
    KeyCode[KeyCode["DOWNARROW"] = 40] = "DOWNARROW";
    KeyCode[KeyCode["LEFTARROW"] = 37] = "LEFTARROW";
    KeyCode[KeyCode["RIGHTARROW"] = 39] = "RIGHTARROW";
    KeyCode[KeyCode["ENTER"] = 13] = "ENTER";
    KeyCode[KeyCode["TAB"] = 9] = "TAB";
    KeyCode[KeyCode["ESC"] = 27] = "ESC";
    KeyCode[KeyCode["FORWARDSLASH"] = 191] = "FORWARDSLASH";
    KeyCode[KeyCode["BACKSPACE"] = 8] = "BACKSPACE";
    KeyCode[KeyCode["DELETE"] = 46] = "DELETE";
    KeyCode[KeyCode["HOME"] = 36] = "HOME";
    KeyCode[KeyCode["END"] = 35] = "END";
    KeyCode[KeyCode["PAGEUP"] = 33] = "PAGEUP";
    KeyCode[KeyCode["PAGEDOWN"] = 34] = "PAGEDOWN";
    KeyCode[KeyCode["ATRATE"] = 50] = "ATRATE";
    KeyCode[KeyCode["HASH"] = 51] = "HASH";
    KeyCode[KeyCode["DOLLAR"] = 52] = "DOLLAR";
    KeyCode[KeyCode["SHIFT"] = 16] = "SHIFT";
    KeyCode[KeyCode["SPACE"] = 32] = "SPACE";
})(KeyCode = exports.KeyCode || (exports.KeyCode = {}));
var specialChars = new Map();
specialChars.set(192, "`");
specialChars.set(189, "-");
specialChars.set(187, "=");
specialChars.set(219, "[");
specialChars.set(221, "]");
specialChars.set(220, "\\");
specialChars.set(186, ";");
specialChars.set(222, "'");
specialChars.set(223, ",");
specialChars.set(190, ".");
specialChars.set(191, "/");
specialChars.set(-192, "~");
specialChars.set(-49, "!");
specialChars.set(-50, "@");
specialChars.set(-51, "#");
specialChars.set(-52, "$");
specialChars.set(-53, "%");
specialChars.set(-54, "^");
specialChars.set(-55, "&");
specialChars.set(-56, "*");
specialChars.set(-57, "(");
specialChars.set(-48, ")");
specialChars.set(-189, "_");
specialChars.set(-187, "+");
specialChars.set(-219, "{");
specialChars.set(-221, "}");
specialChars.set(-220, "|");
specialChars.set(-186, ":");
specialChars.set(-222, '"');
specialChars.set(-188, "<");
specialChars.set(-190, ">");
specialChars.set(-191, "?");
var KeyPress = /** @class */ (function () {
    function KeyPress() {
    }
    KeyPress.shiftIsPressed = function (e) { return e.keyCode === KeyCode.SHIFT; };
    KeyPress.altIsPressed = function (e) { return e.keyCode === KeyCode.ALT; };
    KeyPress.enterIsPressed = function (e) { return e.keyCode === KeyCode.ENTER; };
    KeyPress.upArrowIsPressed = function (e) { return e.keyCode === KeyCode.UPARROW; };
    KeyPress.downArrowIsPressed = function (e) { return e.keyCode === KeyCode.DOWNARROW; };
    KeyPress.leftArrowIsPressed = function (e) { return e.keyCode === KeyCode.LEFTARROW; };
    KeyPress.rightArrowIsPressed = function (e) { return e.keyCode === KeyCode.RIGHTARROW; };
    KeyPress.tabIsPressed = function (e) { return e.keyCode === KeyCode.TAB; };
    KeyPress.escIsPressed = function (e) { return e.keyCode === KeyCode.ESC; };
    KeyPress.forwardSlashIsPressed = function (e) { return e.keyCode === KeyCode.FORWARDSLASH; };
    KeyPress.backspaceIsPressed = function (e) { return e.keyCode === KeyCode.BACKSPACE; };
    KeyPress.deleteIsPressed = function (e) { return e.keyCode === KeyCode.DELETE; };
    KeyPress.homeIsPressed = function (e) { return e.keyCode === KeyCode.HOME; };
    KeyPress.endIsPressed = function (e) { return e.keyCode === KeyCode.END; };
    KeyPress.pageUpIsPressed = function (e) { return e.keyCode === KeyCode.PAGEUP; };
    KeyPress.pageDownIsPressed = function (e) { return e.keyCode === KeyCode.PAGEDOWN; };
    KeyPress.attherateIsPressed = function (e) { return e.keyCode === KeyCode.ATRATE; };
    KeyPress.hashIsPressed = function (e) { return e.keyCode === KeyCode.HASH; };
    KeyPress.dollarIsPressed = function (e) { return e.keyCode === KeyCode.DOLLAR; };
    KeyPress.spaceIsPressed = function (e) { return e.keyCode === KeyCode.SPACE; };
    return KeyPress;
}());
exports.KeyPress = KeyPress;
exports.isLetterChar = function (e) {
    if ((e.keyCode >= 65 && e.keyCode <= 90) || (e.keyCode >= 97 && e.keyCode <= 122)) {
        return String.fromCharCode(e.keyCode);
    }
    else {
        return undefined;
    }
};
exports.isSpecialChar = function (e, altPressed) {
    if (altPressed && specialChars.has(e.keyCode * -1)) {
        return specialChars.get(e.keyCode * -1);
    }
    else if (specialChars.has(e.keyCode)) {
        return specialChars.get(e.keyCode);
    }
    else {
        return undefined;
    }
};
exports.isDigitChar = function (e) {
    if (e.keyCode >= 48 && e.keyCode <= 57) {
        return String.fromCharCode(e.keyCode);
    }
    else {
        return undefined;
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/utils/key-press.js
// module id = 45
// module chunks = 8